/* Gonflair : sur téléphone, les grilles de cartes deviennent des bandes à faire glisser.
   Des points sous chaque bande montrent qu'il y a d'autres cartes et laquelle est affichée (masqués sur ordinateur, voir gonflair.css). */
(function () {
  var SELECTOR = '.gf-cols__grid, .gf-aud__grid, .gf-dos__grid, .gf-pdp__bubbles, .gf-pdp__related .gf-grid';

  function setup(track) {
    if (track.dataset.gfSwipe) return;
    var cards = Array.prototype.filter.call(track.children, function (c) { return c.offsetParent !== null || c.getClientRects().length; });
    if (cards.length < 2) return;
    track.dataset.gfSwipe = '1';

    var dots = document.createElement('div');
    dots.className = 'gf-swipe-dots';
    dots.setAttribute('aria-hidden', 'true');
    cards.forEach(function (card, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.tabIndex = -1;
      d.addEventListener('click', function () {
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
      });
      dots.appendChild(d);
    });
    track.after(dots);

    function update() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      cards.forEach(function (card, i) {
        var c = card.offsetLeft - track.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(c - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === best); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  }

  function init() { document.querySelectorAll(SELECTOR).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
